// extracted by mini-css-extract-plugin
export default {"hotelDescription":"hotel_info_section_hotelDescription__sn-Cn","hotelTitleSection":"hotel_info_section_hotelTitleSection__bM+f2"};